import styled from 'styled-components';

import { Flex } from '../GlobalComponents/Flex';
import { SocialLink } from './components/SocialLink';

const Footer = ({ moveTo }: { moveTo: (url: string) => void }): JSX.Element => {
	return (
		<FooterContainer
			$flexDirection="column"
			$placeContent="center center"
			$alignItems="center"
			$padding="24px 24px"
			$height="auto"
		>
			<ShareText>Share and unite on #BIGGBYNation</ShareText>

			<SocialLink></SocialLink>

			<Flex
				$flexDirection="column"
				$placeContent="center center"
				$alignItems="center"
				$rowGap="10px"
			>
				<div className="d-none d-lg-flex flex-column">
					<Text>
						Copyright {new Date().getFullYear()} BIGGBY
						COFFEE&copy;. All right reserved.
					</Text>
					<Text>
						"BIGGBY" and the Orange Square "B" logo are registered
						trademarks of Global Orange Development, LLC.
					</Text>
				</div>
				<Flex
					$flexDirection="row"
					$placeContent="center center"
					$alignItems="center"
					$columnGap="5px"
				>
					<Link
						href="https://www.biggby.com/privacy-policy/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Privacy Policy
					</Link>
					<Text> | </Text>
					<Link
						href="https://www.biggby.com/terms-of-service/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Terms & Conditions
					</Link>
					<Text> | </Text>

					<LinkText
						onClick={() => moveTo('/accessibility-statement')}
					>
						Accessibility Statement
					</LinkText>
				</Flex>
			</Flex>
		</FooterContainer>
	);
};

export default Footer;

const FooterContainer = styled(Flex)`
	background-color: #222222;
`;

const ShareText = styled.div`
	color: #fdfdfd;
	font-weight: 400;
	font-size: 20px;
	text-align: center;
`;

const Text = styled.div`
	text-align: center;
	color: #fdfdfd;
	font-weight: 400;
	font-size: 14px;
	@media (max-width: 576px) {
		font-size: 12px;
	}
`;

const Link = styled.a`
	text-align: center;
	color: #fdfdfd;
	font-size: 14px;
	@media (max-width: 576px) {
		font-size: 12px;
	}
`;

const LinkText = styled.div`
	text-align: center;
	color: #fdfdfd;
	font-weight: 400;
	font-size: 14px;
	@media (max-width: 576px) {
		font-size: 12px;
	}
	&:hover {
		cursor: pointer;
		text-decoration: underline;
		color: #be5509;
	}
`;
